import { getIn, useFormikContext } from 'formik';

/**
 * Every validation message belonging to one sentence row, deduped, in field
 * order.
 *
 * The rows are built from narrow cells — a 100px number box beside a word — so
 * a field can't carry its own message: it wraps into a tall thin column and
 * knocks the row's words out of line with its inputs. Floating the messages
 * only moved the problem, since two of them in one row anchor to their own
 * cells and cover each other. The row prints them together underneath instead.
 *
 * Held back until the field is touched or a save has been attempted, matching
 * what the fields themselves used to do.
 */
export function useSentenceErrors(names: readonly string[]): string[] {
  const { errors, touched, submitCount } =
    useFormikContext<Record<string, unknown>>();

  const messages: string[] = [];
  names.forEach((name) => {
    const error: unknown = getIn(errors, name);
    if (typeof error !== 'string' || !error) return;
    if (!submitCount && !getIn(touched, name)) return;
    if (!messages.includes(error)) messages.push(error);
  });
  return messages;
}
